import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CircularProgress } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { setSnackBarAlert, caughtError, updateSessionTeamLogo } from '../../redux';
import axios from 'axios';
import getAppConfig from '../../config';
const config = getAppConfig();

const LogoForm = (props) => {

  const session = useSelector((state) => state.session);
  const [logoFileName, setLogoFileName] = useState('');
  //const [logoUrl, setLogoUrl] = useState('');
  const [logoResizedUrl, setLogoResizedUrl] = useState('');
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const onImageChange = event => {
   if (event.target.files && event.target.files[0]) {
     let file = event.target.files[0];
     setImage(URL.createObjectURL(file));

     let formData = new FormData();
     formData.append("file", file);
     setLoading(true);
     axios.put(`${config.api.URL}/team/logo/${props.modalDiaLogId}`, formData).then(apiResponse => {
       const response = apiResponse.data;
       setLoading(false);
       dispatch(setSnackBarAlert({
         openSnackBar: true,
         severity: 'success',
         message: `Success! ${response.message}`
       }));

       /** update session store **/
       if(props.modalDiaLogId === session.teamId) {
         dispatch(updateSessionTeamLogo({
           logoFileName: response.data.logoFileName,
           logoUrl: response.data.logoUrl,
           logoResizedUrl: response.data.logoResizedUrl,
         }));
       }

       props.setOpen(false);
     }).catch(error => {
       console.log(error);
       setLoading(false);
       dispatch(caughtError(error));
     });

   }

  };

  useEffect(() => {
    if(loading && props.modalDiaLogId && props.modalDiaLogId > 0) {
      let URL = `${config.api.URL}/team/${props.modalDiaLogId}`;
      axios.get(URL).then(apiResponse => {
        const response = apiResponse.data;

        setLogoFileName(response.data.logoFileName);
        //setLogoUrl(response.data.logoUrl);
        setLogoResizedUrl(response.data.logoResizedUrl)

      }).catch(error => {
        console.log(error);
      })
    }
    setLoading(false)
  }, [loading, props]);


  let teamLogo = '';
  if(logoFileName !== '' && logoFileName !== null) {
    teamLogo = <p><img className="float-end" src={logoResizedUrl} alt="" /></p>
  }

  return (
    <form>
      <DialogContent sx={{ marginTop: "-20px" }} >

        <div className="row">
          <div className="col">
            { image && <img src={image} alt="team logo" style={{ maxHeight: '100px' }} /> }
            <input type="file" onChange={onImageChange} accept="image/png, image/jpeg" /><br/>
            {loading && <CircularProgress className="mt-4" />}
          </div>
          <div className="col">
            {teamLogo}
          </div>
        </div>


      </DialogContent>
      <DialogActions>
        <button className="btn btn-secondary" onClick={ (e) => {
            e.preventDefault();
            props.setOpen(false);
          } }>Close</button>
      </DialogActions>
    </form>
  )

}

export default LogoForm;
